
import axios from 'axios';
export default {
    async SetDeliveryProvider(orderItemId: string, data: {}) {
        const response = await axios.post('/api/cart/v1/orderitem/delivery/' + orderItemId, data);
        console.log(response);
        return response.data;
    }
}